import { mergePropsClassName } from '@liquorice/allsorts-craftcms-nextjs';
import Box, { BoxProps } from '@/polymorphics/Box';
import * as style from './Card.Inner.css';
import { useCard } from './useCard';
import CardCta from './Card.Cta';

export type CardFootProps = BoxProps<'div'>;

export const CardFoot = ({ children, ...props }: CardFootProps) => {
  const { customText } = useCard();

  return (
    (customText || children) && (
      <Box {...props} {...mergePropsClassName(props, style.foot)}>
        {children || <CardCta />}
      </Box>
    )
  );
};
